export default "__VITE_ASSET__DzezgpEu__"